module.exports = __webpack_public_path__ + "img/young-link-min.d096b862.png";